import {authAxios} from "./axiosClient";
import Cookies from 'universal-cookie';
import {listLeTeTURL, listNgayNghiURL} from "../constants";

export const LichLeTetApi = (params={})=>{
        const url = listLeTeTURL;
        return authAxios().get(url,{params});
}

export const TaoLichLeTetApi = (params={})=>{
        const url = listLeTeTURL;
        return authAxios().post(url,params);
}

export const DeleteLichLeTetApi = (params={})=>{
        const url = listLeTeTURL;
        return authAxios().delete(url,{data:params});
}

export const GetNgayNghiApi = (params={})=>{
        const url = listNgayNghiURL;
        return authAxios().get(url,{params});
}